import { generatePermutations } from '@global/api/data-generation'
import { useMutation } from '@tanstack/react-query'
import { useMemo } from 'react'

export const useGeneratePermutations = () => {
  const { mutate, reset, isError, isPending, isSuccess } = useMutation({
    mutationFn: generatePermutations,
  })

  return useMemo(
    () => ({
      generatePermutations: mutate,
      resetGeneratePermutations: reset,
      isGeneratePermutationsLoading: isPending,
      isGeneratePermutationsSuccess: isSuccess,
      isGeneratePermutationsError: isError,
    }),
    [mutate, reset, isError, isPending, isSuccess],
  )
}
